import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const BlackHorsePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Black Horse"
      slug="/lenders/mis-sold-black-horse-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default BlackHorsePage
